import { FormArray } from '@angular/forms';

export interface CustomControlsFormArray {
  [p: string]: FormArray;
}
